var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2168_8233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.84 2.02074C31.439 0.841481 30.319 0 28.9995 0H7.00049C5.68099 0 4.58074 0.839506 4.16 2.02074L0 14.001V30.001C0 31.1012 0.900741 32 1.99901 32H3.99802C5.09827 32 5.99704 31.0993 5.99704 30.001V28.002H29.997V30.001C29.997 31.1012 30.8978 32 31.996 32H33.9951C35.0953 32 35.9941 31.0993 35.9941 30.001V14.001L31.8341 2.02074H31.84ZM7.00049 22.001C5.34123 22.001 4 20.6617 4 19.0005C4 17.3393 5.33926 16 7.00049 16C8.66173 16 10.001 17.3393 10.001 19.0005C10.001 20.6617 8.66173 22.001 7.00049 22.001ZM29.0015 22.001C27.3422 22.001 26.001 20.6617 26.001 19.0005C26.001 17.3393 27.3402 16 29.0015 16C30.6627 16 32.002 17.3393 32.002 19.0005C32.002 20.6617 30.6627 22.001 29.0015 22.001ZM4 12L7.00049 3.00049H29.0015L32.002 12H4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2168_8233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/Vehicle.9c3b9f2c59cefbda9c08403573f8d7cd.svg";
export { ForwardRef as ReactComponent };